import { type ExamUsageStatus } from '@exam-management/graphql';
import { Label, type LabelProps } from '@shared/components';

import { QSET_EXAM_USAGE_STATUS_COLOR, QSET_EXAM_USAGE_STATUS_TEXT } from './constants';

export interface QSetExamUsageStatusTagProps extends LabelProps {
  status: ExamUsageStatus;
}

export default function QSetExamUsageStatusTag(props: Readonly<QSetExamUsageStatusTagProps>) {
  const { status, ...restProps } = props;

  return (
    <Label color={QSET_EXAM_USAGE_STATUS_COLOR[status]} variant='outlined' {...restProps}>
      {QSET_EXAM_USAGE_STATUS_TEXT[status]}
    </Label>
  );
}
